// Component: ReconcileBadge.jsx
// Purpose: Shared reconcile-state badge (R104.5, R104.11) — renders the DS Badge for a
//          reconcile state with glyph + short/expanded tooltip + aria-label,
//          derived from getReconcileState(state). Used by OrdersTable and
//          PositionsTable (glyph-only) and OrderDetailDrawer (showLabel — glyph +
//          readable short tooltip). title/aria-label identical in both modes.
//          R104.11: renders nothing (null) when state is null — positions and
//          unclassified rows MUST NOT display a badge.

import React from 'react';
import { getReconcileState } from '../../utils/reconcileStates';
import { Badge } from '../ds';

//--> showLabel=false → glyph only (tables). showLabel=true → glyph + readable
//*   shortTooltip text (drawer), e.g. "✓ DeeTrade and the broker agree."
//! R104.11: state=null → no DOM element rendered (null suppression).
//  The 5 active design states (matched, broker_only, algo_only, pending_sweep,
//  reconcile_unavailable) each produce a visually distinct badge.
const ReconcileBadge = ({ state, showLabel = false }) => {
  //! R104.11 — null state = no reconcile classification; suppress badge entirely
  const entry = getReconcileState(state);
  if (entry == null) return null;

  const { badge, variant, shortTooltip, expandedTooltip } = entry;
  return (
    <Badge
      variant={variant}
      size="sm"
      title={`${shortTooltip}\n\n${expandedTooltip}`}
      aria-label={shortTooltip}
      data-reconcile-state={state}
    >
      {showLabel ? `${badge} ${shortTooltip}` : badge}
    </Badge>
  );
};

export default ReconcileBadge;
